import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "font-nunito text-sm" }
const _hoisted_2 = {
  key: 0,
  class: "ml-2 text-ccb-teal-700"
}

import { models } from '@ccb/utils';

export default /*#__PURE__*/_defineComponent({
  __name: 'PriceSticker',
  props: {
    item: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass({ 'line-through': _ctx.item.discountedPrice != null })
    }, " ₹ " + _toDisplayString(_ctx.item.retailPrice), 3),
    (_ctx.item.discountedPrice != null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ₹ " + _toDisplayString(_ctx.item.discountedPrice), 1))
      : _createCommentVNode("", true),
    _createTextVNode(" (taxes included) ")
  ]))
}
}

})